import {FormSection} from '@/components/commons/form-section/FormSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PlannedAccessesSingleAccessFields} from '@/features/planned-accesses/components/accesses-form/planned-accesses-single-access-fields/PlannedAccessesSingleAccessFields'
import {PlannedAccessesTotalCard} from '@/features/planned-accesses/components/planned-accesses-total-card/PlannedAccessesTotalCard'
import {PlannedAccessesFieldsSchema} from '@/features/planned-accesses/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const PlannedAccessesSingleAccessSchema = PlannedAccessesFieldsSchema.pick({
    singleAccesses: true
})
type PlannedAccessesSingleAccessSchema = z.infer<typeof PlannedAccessesSingleAccessSchema>

export const PlannedAccessesFormSingleAccessSection = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<PlannedAccessesSingleAccessSchema>()

    const singleAccesses = useWatch({control, name: 'singleAccesses'})
    const totalSingleAccesses = singleAccesses?.reduce((acc, curr) => {
        return acc + (curr.numberOfAccesses || 0)
    }, 0)

    return (
        <FormSection
            title={t('commons:single_accesses')}
            description={t('planned_accesses:patient_in_person')}
            hasBottomDivider
            fullWidth
        >
            <Flexbox direction="column" gap={6}>
                <PlannedAccessesTotalCard
                    title={t('planned_accesses:total_single_accesses')}
                    total={totalSingleAccesses}
                />
                <PlannedAccessesSingleAccessFields />
            </Flexbox>
        </FormSection>
    )
}
